import { Button, Result } from "antd";
import { Link } from "react-router-dom";

export function Forbidden({ detail }: { detail?: string }) {
  return (
    <Result
      status="403"
      title="403"
      subTitle={detail ?? "このアプリを使う権限が無い。必要なロールを管理者に依頼してください。"}
      extra={
        <Link to="/portal">
          <Button type="primary">ポータルへ戻る</Button>
        </Link>
      }
    />
  );
}

export function NotFound() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="そのページは無い。"
      extra={
        <Link to="/portal">
          <Button type="primary">ポータルへ戻る</Button>
        </Link>
      }
    />
  );
}
